import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './components/layout/Header';
import ProtectedRoute from './components/layout/ProtectedRoute';
import Login from './components/auth/Login';
import Register from './components/auth/Register';
import UserProfile from './components/profile/UserProfile';
import PasswordReset from './components/auth/PasswordReset';
import PasswordResetConfirm from './components/auth/PasswordResetConfirm';
import { Box, CircularProgress } from '@mui/material';
import './App.css';
import TechniqueTracker from './components/techniques/TechniqueTracker';
import EditProfile from './components/profile/EditProfile';
import { useDispatch, useSelector } from 'react-redux';
import { initializeAuth } from './features/auth/authSlice';
import Calendar from './components/schedule/Calendar';
import Home from './components/home/Home';
import Forum from './components/forum/Forum';
import TechniqueNotes from './components/techniques/TechniqueNotes';
import Fitness from './components/fitness/Fitness';
import Roster from './components/roster/Roster';
import UserDetail from './components/roster/UserDetail';
import Notifications from './components/notifications/Notifications';

// Create a theme instance
const theme = createTheme();

function App() {
  const dispatch = useDispatch();
  const { loading } = useSelector(state => state.auth);

  useEffect(() => {
    dispatch(initializeAuth());
  }, [dispatch]);

  if (loading) {
    return (
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh' 
      }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Router>
        <Box sx={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
          <Header />
          <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
            <Routes>
              {/* Public Routes */}
              <Route path="/login" element={<Login />} />
              <Route path="/register" element={<Register />} />
              <Route path="/reset-password" element={<PasswordReset />} />
              <Route path="/reset-password/:uid/:token" element={<PasswordResetConfirm />} />
              
              {/* Protected Routes */}
              <Route path="/profile" element={
                <ProtectedRoute>
                  <UserProfile />
                </ProtectedRoute>
              } />
              <Route path="/techniques" element={
                <ProtectedRoute>
                  <TechniqueTracker />
                </ProtectedRoute>
              } />
              <Route path="/techniques/:classId/notes" element={
                <ProtectedRoute>
                  <TechniqueNotes />
                </ProtectedRoute>
              } />
              <Route path="/schedule" element={
                <ProtectedRoute>
                  <Calendar />
                </ProtectedRoute>
              } />
              <Route path="/profile/edit" element={
                <ProtectedRoute>
                  <EditProfile />
                </ProtectedRoute>
              } />
              <Route path="/forum" element={<Forum />} />
              <Route path="/fitness" element={
                <ProtectedRoute>
                  <Fitness />
                </ProtectedRoute>
              } />
              <Route path="/roster" element={<Roster />} />
              <Route path="/roster/:userId" element={
                <ProtectedRoute>
                  <UserDetail />
                </ProtectedRoute>
              } />
              <Route path="/notifications" element={<Notifications />} />
              
              {/* Default Route */}
              <Route path="/" element={<Home />} />
            </Routes>
          </Box>
          {/* <Footer /> */}
        </Box>
      </Router>
    </ThemeProvider>
  );
}

export default App;
